import R from 'app/assets/R'
import { BaseLayoutReport } from 'app/components/common/BaseLayoutReport'
import { groupData } from './data'
import { useTranslation } from 'react-i18next'
import { useVerifyPermissionAndRedirect } from 'app/common/use-verify-permission-redirect'
import { useEffect } from 'react'
import { ModulePermissionEnum } from 'app/common/permission-module'

const CustomerCareContainer = () => {
  const { t } = useTranslation()
  const { isHavePermissionAndGoBack } = useVerifyPermissionAndRedirect()

  useEffect(() => {
    isHavePermissionAndGoBack(
      ModulePermissionEnum.CUSTOMER_CARE,
      R.strings.customer_care,
    )
  }, [t])

  return (
    <BaseLayoutReport
      data={groupData}
      titleI18nKey={R.strings.customer_care}
      modulePermission={ModulePermissionEnum.CUSTOMER_CARE}
    />
  )
}

export default CustomerCareContainer
